<template>
  <div class="card" :class="{ create: create }" @click="handleClick">
    <div class="create-container" v-if="create">
      <PlusOutlined class="icon" />
      <span>Crear nueva secuencia</span>
    </div>

    <template v-else>
      <div style="flex: 1 1 auto; min-height: 0; overflow: hidden">
        <header>
          <div>
            <!-- <div v-for="channelC in sequence?.channels_customers" style="display: flex">
              <img :src="channelC?.channel?.icon" alt="channel">
            </div> -->
            <!-- {{ sequence?.channels_customers }} -->
            <a-tag class="tag-header" :color="sequence?.sequence_type === SequenceType.Multichannel ? 'purple' : 'blue'">           
              <a-tooltip>
                <template #title>
                  Secuencia de tipo {{ sequence?.sequence_type === SequenceType.Multichannel ? 'Multicanal' : 'Progresivo Automático' }}.
                </template>
                {{ sequence?.sequence_type === SequenceType.Multichannel ? 'Multicanal' : 'Progresivo' }}
              </a-tooltip>
            </a-tag>
            <a-divider type="vertical" class="divider-header"></a-divider>
            <template v-if="sequence?.channels_customers.length !== 0 || sequence?.default_channel">
              <template v-if="sequence?.default_channel">
                <img
                  class="channel-icon"
                  :class="{ 'inactive-icon': sequence?.status === SequenceStatus.Inactive }"
                  :src="String(sequence.default_channel.icon)"
                  :alt="sequence.default_channel.name"
                />
              </template>
              <a-popover
                v-for="(channels_customer, icon) in groupBy(
                  sequence?.channels_customers,
                  (channel) => channel.channel.icon
                )"
                :key="icon"
                :title="channels_customer.at(0)?.channel.name"
              >
                <template #content>
                  <ul>
                    <li v-for="channel in channels_customer" :key="channel.id">
                      <span v-if="channel?.channel?.id == ChannelType.Sms">SMS</span>
                      <span v-else>{{ channel.alias || channel.associate }}</span>
                    </li>
                  </ul>
                </template>
                <img
                  class="channel-icon"
                  :class="{ 'inactive-icon': sequence?.status === SequenceStatus.Inactive }"
                  :src="String(icon)"
                  :alt="channels_customer.at(0)?.channel.name"
                />
                <!-- <a-button type="link">
                  
                </a-button> -->
              </a-popover>
            </template>

            <span v-else>No tiene canales</span>
          </div>

          <a-popover v-model:visible="popoverVisible">
            <template #content>
              <div class="actions" @click="popoverVisible = false">
                <a-button type="text" @click="handleEdit">
                  <EditOutlined /> Editar secuencia
                </a-button>

                <a-button type="text" @click="openContactsModal = true">
                  <UserOutlined /> Ver contactos
                </a-button>

                <a-button
                  type="text"
                  @click="openDataModal = true"
                  v-if="sequence?.sequence_type == SequenceType.Multichannel"
                >
                  <PieChartOutlined /> Ver datos de la secuencia
                </a-button>

                <a-button
                  type="text"
                  @click="openDashboardModal = true"
                  v-if="sequence?.sequence_type == SequenceType.AutomaticProgressive"
                >
                  <PieChartOutlined /> Ver dashboard
                </a-button>

                <a-button type="text" @click="openHistoryModal = true">
                  <FileSyncOutlined /> Ver registro de cambios
                </a-button>

                <!-- <a-button type="text" @click="handleDownload"> -->
                <a-button type="text" @click="openDownloadModal = true">
                  <DownloadOutlined /> Descargar reporte
                </a-button>

                <a-button type="text" danger @click="handleDelete">
                  <DeleteOutlined /> Eliminar secuencia
                </a-button>
              </div>
            </template>

            <MoreOutlined style="font-size: 20px" />
          </a-popover>
        </header>

        <h2 class="name">{{ sequence?.name }}</h2>

        <CustomScrollbar height="calc(100% - 54px)">
          <p class="description">{{ sequence?.description }}</p>
          <p class="description">Campaña: {{ sequence?.portfolio?.name }}</p>
          <p class="description" v-if="sequence?.distribution_type">
            Orden: {{ SequenceDistributionType[sequence?.distribution_type] }} / Priorización:
            {{ sequence?.priority_active === true ? "Sí" : "No" }}
          </p>
        </CustomScrollbar>
      </div>

      <div>
        <a-button type="link" @click="scheduleModalOpen = true" style="padding: 0; height: 22px">
          Ver detalles de horario
        </a-button>
      </div>

      <a-divider type="horizontal" class="divider" />

      <footer>
        <div>
          <a-tag :color="sequence?.status === SequenceStatus.Active ? 'green' : undefined">
            {{ sequence?.status === SequenceStatus.Active ? "Activo" : "Inactivo" }}
          </a-tag>
          <!-- <a-tooltip v-if="sequence?.deleted_queues == true">
            <template #title>
              Algunas colas de esta secuencia fueron eliminadas, recuerda reemplazarla para poder
              activar nuevamente tu secuencia.
            </template>
            <span
              ><a-tag color="warning"> <WarningFilled /> Cola eliminada </a-tag></span
            >
          </a-tooltip> -->
          <!-- <a-tooltip v-if="withoutBalance.length > 0">
            <template #title>
              {{ withoutBalance.length == 1 ? `El canal de` : `Los canales de` }}
              {{ validateBalance }} no cuenta con saldo suficiente para tener activa esta secuencia.
              Recarga tu saldo para reactivarla.
            </template>
            <span><a-tag color="warning"> <WarningFilled /> Falta de saldo </a-tag></span>
          </a-tooltip> -->
          <a-button v-if="validateErrors" style="padding: 0" type="link" @click="openErrors = true">
            <a-tag color="warning">
              <WarningFilled /> Errores: {{ sequence?.errors?.length }}
            </a-tag>
          </a-button>
          ID: {{ sequence?.id }}
        </div>

        <DisableSwitch v-if="sequence" :sequence="sequence" @update="emit('update')" />
      </footer>
    </template>
  </div>

  <a-drawer
    v-model:open="openErrors"
    class="custom-class"
    root-class-name="root-class-name"
    title="Errores"
    placement="right"
  >
    <h3 class="name">{{ sequence?.name }}</h3>
    <p class="description">Campaña: {{ sequence?.portfolio?.name }}</p>
    <p class="errors__list" v-for="error in sequence?.errors">
      <WarningFilled class="icon__warning" />{{ error }}
    </p>
    <template #footer>
      <a-button style="width: 100%; margin: 10px 0" @click="openErrors = false">Cerrar</a-button>
    </template>
  </a-drawer>

  <ChangeHistoryModal
    v-if="openHistoryModal && sequence"
    v-model:open="openHistoryModal"
    :sequence-id="sequence.id"
  />

  <DashboardModal
    v-if="openDashboardModal && sequence"
    v-model:open="openDashboardModal"
    :sequence-id="sequence.id"
  />

  <ScheduleDetailsModal
    v-if="scheduleModalOpen"
    sequence
    :visible="scheduleModalOpen"
    :chatbot="sequence"
    @close="scheduleModalOpen = false"
    @edit="handleEdit"
  />

  <DownloadReportModal
    v-if="openDownloadModal && sequence"
    v-model:open="openDownloadModal"
    :sequence-id="sequence.id"
    :sequence-name="sequence.name"
  />

  <DataModal
    v-if="openDataModal && sequence"
    v-model:open="openDataModal"
    :sequence-id="sequence.id"
    :sequence-name="sequence.name"
  />

  <ContactsModal
    v-if="openContactsModal && sequence"
    v-model:open="openContactsModal"
    :sequence-id="sequence.id"
    :sequence-name="sequence.name"
  />
</template>

<script setup lang="ts">
import {
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  FileSyncOutlined,
  MoreOutlined,
  PieChartOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
  UserOutlined,
  WarningFilled,
} from "@ant-design/icons-vue";
import { useRouter } from "vue-router";
import { createVNode, ref, computed } from "vue";
import { Modal, message } from "ant-design-vue";
import { groupBy } from "lodash";

import { Sequence, SequenceStatus } from "@/@types/flows/sequences";
import { sequenceService } from "@/app/flows/sequences/services/Sequence.service";

import ChangeHistoryModal from "@/app/flows/sequences/components/modals/ChangeHistoryModal.vue";
import DashboardModal from "@/app/flows/sequences/components/modals/DashboardModal.vue";
import ScheduleDetailsModal from "@/app/chatbots/components/modals/ScheduleDetailsModal.vue";
import DownloadReportModal from "@/app/flows/sequences/components/modals/DownloadReportModal.vue";
import DataModal from "@/app/flows/sequences/components/modals/DataModal.vue";
import ContactsModal from "@/app/flows/sequences/components/modals/ContactsModal.vue";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import DisableSwitch from "@/app/flows/sequences/components/buttons/DisableSwitch.vue";
import { SequenceDistributionType } from "@/@types/flows/sequences";
import { SequenceType } from "@/app/flows/sequences/utils/enums";
import { ChannelType } from "@/app/shared/utils/enums";

const props = defineProps<{ create: boolean; sequence?: Sequence }>();

const emit = defineEmits<{ create: []; update: [] }>();

const router = useRouter();

const openHistoryModal = ref(false);
const openDashboardModal = ref(false);
const openDownloadModal = ref(false);
const openDataModal = ref(false);
const openContactsModal = ref(false);
const scheduleModalOpen = ref(false);

const popoverVisible = ref(false);
const openErrors = ref(false);

const handleClick = () => {
  if (!props.create) return;

  emit("create");
};

const handleEdit = () => {
  router.push(`/flows/sequences/${props.sequence?.id}`);
};

// const handleDownload = async () => {
//   if (!props.sequence) return;

//   const response = await sequenceService.downloadReport(props.sequence.id);

//   downloadFile(response, `sequence-${props.sequence.name}.xlsx`, { useResponseFileName: true });
// };

const validateErrors = computed(() => {
  return props.sequence?.errors?.length > 0;
});
const withoutBalance = computed(() => {
  let withoutBalanceAux: string[] = [];
  props.sequence?.channels_balance?.forEach((el) => {
    if (el.balance < 1) {
      withoutBalanceAux.push(el.name);
    }
  });
  return withoutBalanceAux;
});

const validateBalance = computed(() => {
  return withoutBalance.value.length > 0 ? withoutBalance.value.join(", ") : null;
});

const handleDelete = async () => {
  Modal.confirm({
    icon: createVNode(QuestionCircleOutlined),
    centered: true,
    title: "¿Estás segur@ de eliminar esta secuencia?",
    content:
      "Recuerda que se dejará de contactar a todos los nuevos registros que ingresen a tu campaña.",
    okText: "Eliminar",
    onOk: async () => {
      if (!props.sequence) return;

      await sequenceService.delete(props.sequence.id);

      message.success("Secuencia eliminada");

      emit("update");
    },
  });
};
</script>

<style scoped lang="sass">
.tag-header
  margin-inline-end: 0

.divider-header
  font-size: 22px

.divider
  margin: 10px 0
  background-color: $gray-5

.card
  padding: 12px 20px
  width: 100%
  background-color: $gray-2
  border: 1px solid $gray-5
  border-radius: 8px
  height: 210px
  display: flex
  flex-direction: column

  &.create
    border-style: dashed
    border-color: $blue-6
    background-color: $blue-1
    color: $primary
    cursor: pointer

    .create-container
      width: 100%
      height: 100%
      display: flex
      flex-direction: column
      gap: 2px
      align-items: center
      justify-content: center

      .icon
        font-size: 30px

      span
        font-size: 12px

  header
    display: flex
    justify-content: space-between
    margin-bottom: 10px

    .type
      font-size: 12px
      color: $text-secondary
      line-height: 20px

  footer
    display: flex
    justify-content: space-between
    align-items: center

.name
  font-weight: 600
  font-size: 16px
  color: $gray-9
  margin-bottom: 2px

.description
  margin: 0
  color: $gray-7
  font-size: 13px

.actions
  display: flex
  flex-direction: column
  gap: 8px

  > button
    text-align: left

.channel-icon
  width: 20px
  height: 20px
  margin-right: 8px

.inactive-icon
  filter: grayscale(100%)

.errors__list
  margin-top: 15px
  display: flex
  align-items: start
  .icon__warning
    color: rgba(250, 173, 20, 1)
    margin-top: 4px
    margin-right: 5px
</style>
